import { SessionStorageKeys } from '../types/SessionStorage';
import { Storage } from './Storage';

export const isOnline = () => Storage.readItem(SessionStorageKeys.IS_ONLINE) === 'true';
